const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Returns the number of days in a given month.
 * @param {number} year
 * @param {number} month - 1-based (1 = January, 12 = December)
 */
export function getLastDayOfMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

/**
 * Returns the display name for a month.
 * @param {number|string} month - 1-based, accepts "07" or 7
 * @returns {string}
 */
export function monthName(month) {
  return monthNames[Number(month) - 1];
}

function formatDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/**
 * Builds an API date range object for a given month.
 * start_before is exclusive.
 * @param {number} year
 * @param {string} monthStr - zero-padded month string, e.g. "03"
 * @returns {{ start_after: string, start_before: string }}
 */
export function monthToRange(year, monthStr) {
  const nextMonth = new Date(year, parseInt(monthStr), 1);

  return {
    start_after: `${year}-${monthStr}-01`,
    start_before: formatDate(nextMonth),
  };
}

/**
 * Populates the calendar grid view with events that overspill into view from the previous and next month.
 *
 * @param {number} year
 * @param {string} monthStr - zero-padded month string, e.g. "03"
 * @returns {{ start_after: string, start_before: string }}
 */
export function monthToCalendarGridRange(year, monthStr) {
  const monthIdx = parseInt(monthStr) - 1;
  const firstOfMonth = new Date(year, monthIdx, 1);
  const lastOfMonth = new Date(year, monthIdx + 1, 0);

  const gridStart = new Date(firstOfMonth);
  gridStart.setDate(firstOfMonth.getDate() - firstOfMonth.getDay());

  const gridEnd = new Date(lastOfMonth);
  gridEnd.setDate(lastOfMonth.getDate() + (6 - lastOfMonth.getDay()));

  gridEnd.setDate(gridEnd.getDate() + 1);

  return { start_after: formatDate(gridStart), start_before: formatDate(gridEnd) };
}

/**
 * Returns the current calendar month as a zero-padded month string, e.g. "07".
 * @returns {string}
 */
export function currentMonthNumber() {
  return String(new Date().getMonth() + 1).padStart(2, '0');
}

/**
 * Formats a "YYYY-MM" string into a display label.
 * Shows only the month name if the year matches the current year,
 * otherwise shows "Month YYYY".
 * @param {string} yearMonthStr - e.g. "2025-03"
 * @param {boolean} alwaysShowYear Whether to always show the year even if the year is the same as the current
 * @returns {string}
 */
export function formatMonthLabel(yearMonthStr, alwaysShowYear) {
  const [selYear, selMonth] = yearMonthStr.split('-');
  const monthName = monthNames[parseInt(selMonth) - 1];
  const currentRealYear = new Date().getFullYear().toString();

  if (selYear !== currentRealYear || alwaysShowYear) {
    return `${monthName} ${selYear}`;
  }

  return monthName;
}
